module.exports = __webpack_public_path__ + "static/media/work-experiance.11d2e1a3.jpg";